import MarketProfile from "./marketProfile";
import { useTranslation } from "../../../../i18n/useTranslation";

const MarketUSA = () => {
  const { t } = useTranslation();
  return (
    <MarketProfile
      tag="Market · US"
      name="Tapaswe USA"
      intro={t("marketsUsa.intro")}
      offices={[
        { label: "", address: "Philadelphia, PA" },
        { label: "", address: "Charlotte, NC" },
      ]}
    />
  );
};

export default MarketUSA;
